import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 用户测评信息分页列表
export function getUserAssessPager(data) {
  return request({
    url: apiConfig.userAssess.api.pager.url,
    method: "post",
    data
  });
}

// 用户测评信息分页列表搜索功能
export function searchUserAssessPager(data) {
  return request({
    url: apiConfig.userAssess.api.pager.url,
    method: "post",
    data
  });
}
// 查看测评详情
export function getScaleList(req) {
  return request({
    url: apiConfig.userAssess.api.getScaleList.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 查看测评报告
export function viewReport(req) {
  return request({
    url: apiConfig.userAssess.api.viewReport.url,
    method: "get",
    params: req
  });
}
// 查看考场报告
export function viewExamReport(req) {
  return request({
    url: apiConfig.userAssess.api.viewExamReport.url,
    method: "get",
    params: req,
  });
}

// 批量下载测评报告
export function downloadReportBatch(req) {
  return request({
    url: apiConfig.userAssess.api.downloadReportBatch.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
export function getScaleListByExamUserId(req) {
  return request({
    url: apiConfig.userAssess.api.getScaleList.url,
    method: "get",
    params: {
      examUserId: req.examUserId
    }
  });
}

//重置密码
export function resetUserAccountPassword(req) {
  return request({
    url: apiConfig.userAssess.api.resetUserAccountPassword.url,
    method: "post",
    data: req
  });
}

//生成报告ZIP
export function exportReports(exportInfoForm) {
  return request({
    url: apiConfig.userAssess.api.downloadReportZip.url,
    method: "post",
    data: exportInfoForm
  });
}
//点击连接下载报告zip
export function downloadReportZipUrl() {
  return request({
    url: apiConfig.userAssess.api.downloadReportZipUrl.url,
    method: "get",
    responseType: "blob"
  });
}

//轮询生成证书zip是否完成
export function isOver() {
  return request({
    url: apiConfig.userAssess.api.isOver.url,
    method: "get"
  });
}

// 下载量表测评报告pdf
export function downloadScaleReportPdf(req) {
  return request({
    url: apiConfig.userAssess.api.downloadScaleReportPdf.url,
    method: "post",
    data: req,
    responseType: "blob"
  });
}
// 下载考场报告
export function downloadExamReport(req) {
  return request({
    url: apiConfig.userAssess.api.downloadExamReportPdf.url,
    method: "post",
    data: req,
    responseType: "blob",
  });
}
//批量导出考场报告zip
export function batchExportExamReportZipAsync(exportInfoForm) {
  return request({
    url: apiConfig.userAssess.api.batchExportExamReportZipAsync.url,
    method: 'post',
    data: exportInfoForm,
  });
}

//点击连接下载报告zip列表版本
export function downloadReportZipUrlAsync(id) {
  return request({
    url: apiConfig.userAssess.api.downloadReportZipUrlAsync.url(id),
    method: 'get',
    responseType: 'blob',
  });
}

export function getDownloadList() {
  return request({
    url: apiConfig.userAssess.api.downloadPageQuery.url,
    method: 'get',
  });
}

// 用户测评信息导出
export function exportUserAssessInfo(req) {
  return request({
    url: apiConfig.userAssess.api.exportUserAssessInfo.url,
    method: "post",
    data: req,
    responseType: "blob",
  });
}
